import { client, handleRequestBody } from "./client.ts";

export interface CurrentUser {
	id: string;
	name: string;
	email: string;
	// Absent on API versions that predate the onboarding-recovery contract.
	onboarding?: boolean;
}

export interface MeAccount {
	id: string;
	name: string;
	admin: boolean;
	logo_url?: string;
	role?: {
		id: string;
		name: string;
	};
}

export type PermissionsTree = Record<string, unknown>;

export interface MeResponse {
	user: CurrentUser;
	account: MeAccount | null;
	accounts: MeAccount[];
	permissions: PermissionsTree;
}

export function getMe(token?: string): Promise<MeResponse> {
	return handleRequestBody(() =>
		client.get<MeResponse>(
			"/me",
			token ? { headers: { Authorization: `Bearer ${token}` } } : undefined,
		),
	);
}
